// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YqQtq","tabsBox":"styles_tabsBox__1R4iI","createButton":"styles_createButton__xL_nH"};